export default function useDataConfiguration(props) {
  return {
    variables: {
      appointment_id: props.data.appointment._id,
      treatment_field_id: Number(props.column.colId),
    },
  }
}
